import { QueryKeys } from "@/lib/types";
import { StatementPeriod } from "@/openapi/generated";
import type { BalanceStatementRequest } from "./fetch-student-statements";
import { DEFAULT_STATEMENT_PERIOD } from "./statement-period";

export const USER_BALANCE_STATEMENTS_STALE_TIME_MS = 2 * 60 * 1000;
export const STUDENT_STATEMENT_PAGE_SIZE = 20;
export const STATEMENT_SUMMARY_PAGE_SIZE = 1;

export function userBalanceStatementsQueryKey(
  userId: number,
  request: BalanceStatementRequest,
  page: number,
  pageSize: number,
) {
  return [
    QueryKeys.Balance,
    "user-statements",
    userId,
    request,
    page,
    pageSize,
  ] as const;
}

function emptyFamilyStatementFilters(userId: number): BalanceStatementRequest {
  return {
    userId,
    studentId: null,
    descriptionSearch: null,
    transactionCode: null,
    displayStatus: null,
    from: null,
    to: null,
  };
}

/** Default ParentStatementPanel queries (summary + first table page). */
export function defaultMemberFamilyStatementRequests(userId: number): {
  summary: BalanceStatementRequest;
  table: BalanceStatementRequest;
} {
  const filters = emptyFamilyStatementFilters(userId);
  return {
    summary: { ...filters, period: DEFAULT_STATEMENT_PERIOD },
    table: { ...filters, period: StatementPeriod.All },
  };
}
